module.exports = __webpack_public_path__ + "img/freccetta_giù_small.0e1070df.svg";